import React from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
function editorCheckLabel(disallowed) {
  var who = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Editor';
  return disallowed ? /*#__PURE__*/_jsxs("i", {
    children: ["(Disabled: You need ", who, " access)"]
  }) : null;
}
export { editorCheckLabel };